export default "__VITE_ASSET__CcTzQ9_P__"